function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.25 4.25H4.25C3.14543 4.25 2.25 5.14543 2.25 6.25V26.25C2.25 27.3546 3.14543 28.25 4.25 28.25H12.25C13.3546 28.25 14.25 27.3546 14.25 26.25V6.25C14.25 5.14543 13.3546 4.25 12.25 4.25Z",
  stroke: "#231F20",
  strokeMiterlimit: 10
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.25 4.25H23.25",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.25 12.25V10.25",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.25 17.25V15.25",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.25 22.25V20.25",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M30.25 12.25V10.25",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M30.25 17.25V15.25",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M30.25 22.25V20.25",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M25.25 28.25H23.25",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M20.25 4.25C19.7196 4.25 19.2109 4.46071 18.8358 4.83579C18.4607 5.21086 18.25 5.71957 18.25 6.25V7.25",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M28.25 4.25C28.7804 4.25 29.2891 4.46071 29.6642 4.83579C30.0393 5.21086 30.25 5.71957 30.25 6.25V7.25",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M28.25 28.25C28.7804 28.25 29.2891 28.0393 29.6642 27.6642C30.0393 27.2891 30.25 26.7804 30.25 26.25V25.25",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M20.25 28.25C19.7196 28.25 19.2109 28.0393 18.8358 27.6642C18.4607 27.2891 18.25 26.7804 18.25 26.25V25.25",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

function SvgCompareItemsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareItemsIcon);
export default __webpack_public_path__ + "static/media/compare-items-icon.3a87b409.svg";
export { ForwardRef as ReactComponent };